export const texts = [
  // panel 1 — opening
  [
    { text: 'rescinded into sun', count: 300, fontSize: 36 },
    { text: 'particular particulates part it accumulates', count: 700, fontSize: 36 },
    { text: 'culminative', count: 1000, fontSize: 90 },
    { text: 'and directionless', count: 1400, fontSize: 50 },
    { text: '', count: 1800, fontSize: 10 },
  ],
  // panel 2 — middle
  [
    { text: 'but rushed out wind', count: 300, fontSize: 54 },
    { text: 'towards dust and snow', count: 700, fontSize: 48 },
    { text: 'immobilized glass bridge prison', count: 1100, fontSize: 40 },
    { text: '', count: 1500, fontSize: 10 },
  ],
  // panel 3 — end
  [
    { text: 'and then when it returns', count: 200, fontSize: 60 },
    { text: 'lungs deep breath scarring', count: 600, fontSize: 100 },
    { text: 'no more air to breathe', count: 1000, fontSize: 160 },
    { text: '', count: 1400, fontSize: 10 },
  ],
];

export default texts;
